import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../../lib/api';
import { qk } from '../auth/api';

export type OrderNote = {
  id: string;
  body: string;
  authorType: 'CUSTOMER' | 'ORG';
  createdAt: string;
  author: { firebaseUid: string; name: string | null; email: string | null };
};

export function useOrgOrderNotes(orderId: string | null) {
  return useQuery({
    queryKey: ['orgOrderNotes', orderId],
    enabled: !!orderId,
    queryFn: async () => {
      const { data } = await api.get<{ notes: OrderNote[] }>(
        `/organization/orders/${orderId}/notes`
      );
      return data.notes;
    },
    staleTime: 10_000,
  });
}

export function useAddOrgOrderNote(orderId: string) {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (body: string) => {
      const { data } = await api.post<{ note: OrderNote }>(
        `/organization/orders/${orderId}/notes`,
        { body }
      );
      return data.note;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['orgOrderNotes', orderId] });
      qc.invalidateQueries({ queryKey: ['org:order-notes:detail', orderId] });
      qc.invalidateQueries({ queryKey: ['org:order-notes:inbox'] });
      qc.invalidateQueries({ queryKey: qk.me });
    },
  });
}
